<template>
  <div class="rating-stars">
    <span
      v-for="index in maxStars"
      :key="index"
      class="star"
    >
      <span
        v-if="index <= Math.floor(rating)"
        class="full-star"
      >
        ★
      </span>
      <span
        v-else-if="index === Math.floor(rating) + 1 && rating % 1 !== 0"
        class="half-star"
      >
        <span class="full">★</span>
        <span class="empty">☆</span>
      </span>
      <span
        v-else
        class="empty-star"
      >☆</span>
    </span>
  </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{
  rating?: number
  maxStars?: number
}>(), {
  rating: 0,
  maxStars: 5,
});
</script>

<style lang="scss" scoped>
.rating-stars {
  font-size: 25px;
  user-select: none;
  display: flex;
  align-items: center;

  .star {
    cursor: pointer;
    position: relative;
  }

  .full-star, .half-star, .half-star span, .empty-star {
    width: 21px;
    display: inline-block;
    color: var(--surfaces-on-surface-variable);
  }

  .full-star {
    color: var(--accent-primary);
  }

  .half-star {
    display: flex;
    justify-content: center;
    align-items: center;

    .full {
      color: var(--accent-primary);
      width: 50%;
      overflow: hidden;
    }

    .empty {
      transform: scaleX(-1);
      color: var(--surfaces-on-surface-variable);
      width: 50%;
      overflow: hidden;
      z-index: 1;
    }
  }

}
</style>
